import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import { Alert, Box, IconButton, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormDataContext } from '../../../app/providers/formValues/lib/FormDataContext';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { parseISO } from 'date-fns';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
	coverageData: string;
	isDateInPast: boolean;
}

const EditableDate = (props: Props) => {
	const { setPolicyStartDate, setLeaseEffectiveDate } = useContext(FormDataContext);
	const [dateEditable, setDateEditable] = useState(false);
	const prevDate = useRef<string>('');
	const { coverageData, isDateInPast } = props

	const handleEffectiveDate = (data: Date | null) => {
		// Format the calendar date the user selected (don't convert to UTC)
		const formattedDate = dayjs(data).format('YYYY-MM-DD');
		setPolicyStartDate(formattedDate);

		// Compare calendar date against UTC today (server's "today")
		const utcTodayStr = dayjs.utc().format('YYYY-MM-DD');
		if (formattedDate === utcTodayStr) {
			setLeaseEffectiveDate(formattedDate);
		}

		prevDate.current = formattedDate;
	}

	const handleEdit = () => {
		setDateEditable(true)
	}
	const handleClose = () => {
		setDateEditable(false)
	}
	useEffect(() => {
		if(prevDate.current === dayjs(coverageData).format('YYYY-MM-DD')) {
			setDateEditable(false)
		}
	}, [coverageData]);
	const maxDateLimit = dayjs.utc().add(90, 'days').format('YYYY-MM-DD');
	return (
		<div style={{ width: '100%' }}>
			{isDateInPast && (
				<Alert severity="warning" sx={{ mb: 2 }}>
					Your coverage start date was set to a past date, so we updated it to the closest valid one. If you’d like to change it, you can do so below.
				</Alert>
			)}
			{dateEditable ? (
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<DatePicker
						sx={{flex: '0 0 80%'}}
						value={parseISO(coverageData)}
						maxDate={new Date(maxDateLimit)}
						label="Coverage Start Date"
						format={"yyyy-MM-dd"}
						onChange={handleEffectiveDate}
						shouldDisableDate={(date) => {
							// Compare calendar date against UTC today (server's "today")
							const dateStr = dayjs(date).format('YYYY-MM-DD');
							const utcTodayStr = dayjs.utc().format('YYYY-MM-DD');
							return dateStr <= utcTodayStr;
						}}
						disableHighlightToday
					/>
					<div>
						<IconButton aria-label="edit" size="medium" onClick={handleClose}>
							<CloseIcon fontSize="inherit"/>
						</IconButton>
					</div>
				</Box>
			) : (
				<Box display="flex" alignItems="center" sx={{ justifyContent: 'space-between', }}>
					<Typography>Coverage Start Date</Typography>
					<Typography fontWeight={800} textAlign="right">
						<IconButton aria-label="edit" size="small" onClick={handleEdit}>
							<EditIcon fontSize="inherit"/>
						</IconButton>
						{coverageData && dayjs(coverageData).format('MM/DD/YYYY')}

					</Typography>
				</Box>
			)}
		</div>
	)
}

export default EditableDate
